import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Input from "../../../components/composed/FormElements/Input";
import Title from "../../../components/composed/Title";
import Button from "../../../components/atomic/Button";
import { LoanApplicationService } from "../../../services/LoanApplication";
import { notify } from "../../../../../src/shared/context/AlertContext";

const LAPAddCoApplicant = (props: any) => {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 640);
  const { sourceEntityID } = useParams();

  useEffect(() => {
    const handleResize = () => setIsMobileScreen(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeSidebar = () => {
    props.closeSidebar();
  };

  const validateMobile = (number: string) => /^[6-9]\d{9}$/.test(number);

  const handleMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length <= 10) {
      setMobile(value);
      if (value.length === 10 && validateMobile(value)) setError("");
    }
  };

  const handleStartApplication = async () => {
    if (!validateMobile(mobile)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await LoanApplicationService.startCoApplicantApplication(
        {
          token: props.token,
          payload: {
            mobile,
            loanApplicationID: props.loanID,
            redirectURL: window?.location?.href
          },
          pageName: props.pageName,
          isPlatformDashboard: !props.isLenderDashboard,
          sourceEntityID
        }
      );

      if (response?.status && response?.data?.url) {
        closeSidebar();

        window.location.assign(response.data.url);
        // window.open(response.data?.url, "_blank");
      } else notify({ title: "Error", type: "error", text: response.error });
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen p-10 flex flex-col">
      <div className="pt-6">
        <Title
          onClose={closeSidebar}
          name="Add Co-applicant"
        />
      </div>

      <div
        className={`flex-1 mt-4 ${
          isMobileScreen ? "py-4" : "px-10"
        } flex justify-start`}
      >
        <div
          className={`border-4 border-r-8 rounded-lg border-gray-600 flex flex-col justify-between p-4 w-full ${
            isMobileScreen ? "max-w-full" : "max-w-3xl"
          }`}
          style={{
            height: "600px" // ✅ Fixed height (use inline to ensure consistency)
          }}
        >
          <div>
            <div className="text-lg">Co-Applicant Details</div>

            <div className="mt-6">
              <Input
                label="Co-Applicant Mobile Number"
                type="text"
                value={mobile}
                onChange={handleMobileChange}
                placeholder="Enter Mobile Number"
                error={error}
                maxLength={10}
              />
              {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
            </div>
          </div>

          <div className="mt-4">
            <Button
              onClick={handleStartApplication}
              disabled={loading}
              color="primary"
              className="w-full"
            >
              {loading ? "Starting..." : "Start Application"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LAPAddCoApplicant;
